const LastMatch = {
    props: ['mode'],
    setup(props) {
        const lastMatch = Vue.ref(null);
        const i18n = Vue.ref(null);
        const statsKeys = Vue.ref(
            props.mode === '1'
            ? ['shots', 'hits', 'time_on_attack', 'pass_percent', 'faceoff_percent', 'penalty_minutes', 'powerplay_goals', 'shorthanded_goals']
            : ['goals', 'assists', 'points', 'shot_percent', 'hits', 'giveaways', 'takeaways']
        );

        fetch(LAST_MATCH_URL + '?' + new URLSearchParams({mode: props.mode}).toString())
            .then(response => response.json())
            .then(data => {
                lastMatch.value = data.data.match;
                i18n.value = data.data.i18n;
            });

        return {
            i18n,
            lastMatch,
            statsKeys,

            avatar,
            logo,
            link,
            title,
            offset,
        };

        function logo(side) {
            return props.mode === '1' ? lastMatch.value['player' + side].club.logo : lastMatch.value['team' + side].avatar;
        }

        function avatar(side) {
            return props.mode === '1' ? lastMatch.value['player' + side].avatar : lastMatch.value['team' + side].avatar;
        }

        function title(side) {
            return props.mode === '1' ? lastMatch.value['player' + side].tag : lastMatch.value['team' + side].title;
        }

        function link(side) {
            return props.mode === '1' ? lastMatch.value['player' + side].link : lastMatch.value['team' + side].link;
        }

        function offset(side) {
            const mode = props.mode === '1' ? 'player' : 'team';

            return lastMatch.value[mode + 'One'].goals + lastMatch.value[mode + 'Two'].goals > 0
                ? lastMatch.value[mode + side].goals / (lastMatch.value[mode + 'One'].goals + lastMatch.value[mode + 'Two'].goals) * 100
                : 0;
        }
    },
    template: `
        <div class="row" v-if="lastMatch">
            <div class="col-sm-12 my-4">
                <div class="rounded-4 bg-dark px-2 px-lg-3 px-xl-4 px-xxl-5 pt-5 pb-4">
                    <div class="row">
                        <div class="col-6 col-xl-3 col-xxl-4 d-flex flex-column flex-lg-row flex-xl-column flex-xxl-row align-items-center order-1 position-relative">
                            <div class="image-line-shadow image-line-shadow_blue">
                                <span class="image-line-shadow__bg-shadow"></span>
                                <a :href="link('One')" class="image-line-shadow__image">
                                    <img :src="mode === '1' ? avatar('One') : logo('One')" class="rounded-circle image-line-shadow__image" :alt="title('One')">
                                    <img v-if="mode === '1'" class="team-player-cards__item-image-profile image-line-shadow__image rounded-circle position-absolute" :src="logo('One')" style="height: 3rem; top:80%;">
                                </a>
                            </div>
                            <div class="ms-0 ms-lg-4 ms-xl-0 ms-xxl-4 mt-4 mt-lg-0 mt-xl-4 mt-xxl-0 text-center text-lg-start text-xl-center text-xxl-start">
                                <a :href="link('One')" class="text-decoration-none fs-5 fw-bold">{{ title('One') }}</a>
                                <br>
                                <span class="text-muted">{{ mode === '1' ? lastMatch.playerOne.name : lastMatch.playersCount }}</span>
                            </div>
                        </div>
                        <div v-for="(game, index) in lastMatch.games" :class="'col text-center d-flex flex-column align-self-center order-' + (index + 3) + ' order-xl-' + (index + 3)">
                            <div class="text-muted mt-xl-0 mt-4">{{ index + 1 }}-й матч</div>
                            <div class="last-match__total">
                                <a :href="game.link" class="text-decoration-none fw-bold value">{{ game.score }}</a>
                            </div>
                        </div>
                        <div :class="'col-6 col-xl-3 col-xxl-4 d-flex flex-column flex-lg-row flex-xl-column flex-xxl-row align-items-center order-2 order-xl-' + (lastMatch.games.length + 2) + ' justify-content-lg-end justify-content-xxl-end'">
                            <div class="image-line-shadow image-line-shadow_purple order-1 order-lg-2 order-xl-1 order-xxl-2">
                                <span class="image-line-shadow__bg-shadow"></span>
                                <a :href="link('Two')" class="image-line-shadow__image">
                                    <img :src="mode === '1' ? avatar('Two') : logo('Two')" class="rounded-circle image-line-shadow__image" :alt="title('Two')">
                                    <img v-if="mode === '1'" class="team-player-cards__item-image-profile image-line-shadow__image rounded-circle position-absolute" :src="logo('Two')" style="height: 3rem; top:80%;">
                                </a>
                            </div>
                            <div class="me-0 me-lg-4 me-xl-0 me-xxl-4 mt-4 mt-lg-0 mt-xl-4 mt-xxl-0 text-center text-lg-start text-xl-center text-xxl-start order-2 order-lg-1 order-xl-2 order-xxl-1">
                                <a :href="link('Two')" class="text-decoration-none fs-5 fw-bold">{{ title('Two') }}</a>
                                <br/>
                                <span class="text-muted">{{ mode === '1' ? lastMatch.playerTwo.name : lastMatch.playersCount }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="last-match__line mt-5">
                        <span class="blue" :style="'width: ' + offset('One') + '%;'"></span>
                        <img :style="'left: calc(' + offset('One') + '% - 20px);'" src="/images/line-hockey.svg" alt="">
                        <span class="purple" :style="'width: ' + offset('Two') + '%;'"></span>
                    </div>
                    <div class="last-match__commands-total">
                        <div class="last-match__commands-total__block">
                            <div class="last-match__commands-total__block-command-mobile">{{ title('One') }}</div>
                            <div class="last-match__commands-total__item">
                                <div class="last-match__commands-total__item-key">{{ i18n.games }}</div>
                                <div class="last-match__commands-total__item-value">{{ lastMatch.gamesCount }}</div>
                            </div>
                            <div v-for="key in statsKeys" :key="key" class="last-match__commands-total__item">
                                <div class="last-match__commands-total__item-key">{{ i18n[key] }}</div>
                                <div class="last-match__commands-total__item-value">
                                    {{ mode === '1' ? lastMatch.playerOne[key] : lastMatch.teamOne[key] }}{{ key.indexOf('percent') !== -1 ? '%' : '' }}
                                </div>
                            </div>
                        </div>
                        <div class="last-match__commands-total__line"></div>
                        <div class="last-match__commands-total__block">
                            <div class="last-match__commands-total__block-command-mobile">{{ title('Two') }}</div>
                            <div class="last-match__commands-total__item">
                                <div class="last-match__commands-total__item-key">{{ i18n.games }}</div>
                                <div class="last-match__commands-total__item-value">{{ lastMatch.gamesCount }}</div>
                            </div>
                            <div v-for="key in statsKeys" :key="key" class="last-match__commands-total__item">
                                <div class="last-match__commands-total__item-key">{{ i18n[key] }}</div>
                                <div class="last-match__commands-total__item-value">
                                    {{ mode === '1' ? lastMatch.playerTwo[key] : lastMatch.teamTwo[key] }}{{ key.indexOf('percent') !== -1 ? '%' : '' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
}

const homeApp = Vue.createApp({});

homeApp
  .component('LastMatch', LastMatch)

homeApp.mount('#homeApp');
homeApp.config.errorHandler = (error) => {
    console.log(error);
}
